export const ManagementPermissions = {
  //as per as management department will see everything

  "Managing Director": [
    {
      path: "#",
      label: "Merchandising",
      icon: "fas fa-store me-1",
    },

    {
      path: "/merchandising/purchase-contracts",
      label: "PC/JOBS",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/techpacks",
      label: "Techpacks",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/sample/consumptions",
      label: "Consumption",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/sors",
      label: "SOR",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/costings",
      label: "BOM & Costing",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/purchases",
      label: "PO",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/budgets",
      label: "Budgets",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    {
      path: "/merchandising/bookings",
      label: "Bookings",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    {
      path: "/merchandising/bookings-overview",
      label: "Bookings Overview",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/merchandising/proformas",
      label: "PI",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    //COMMERCIAL
    {
      path: "#",
      label: "Commercial",
      icon: "fas fa-store me-1",
    },
    {
      path: "/commercial/lcs",
      label: "LC",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    {
      path: "#",
      label: "Development",
      icon: "fas fa-store me-1",
    },
    {
      path: "/admin/designs",
      label: "Designs",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    {
      path: "#",
      label: "Store",
      icon: "fas fa-store me-1",
    },
    {
      path: "/admin/stores",
      label: "Manage",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/admin/store-receives",
      label: "Receives",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/admin/store-issues",
      label: "Issues",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },
    {
      path: "/admin/store/left-overs",
      label: "Left Over",
      icon: "fas fa-store  me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores",
      label: "Sub-Store",
      icon: "fas fa-store me-1",
    },
    //SUBSTORE SUBMENU

   

     {
      path: "/sub-stores/Stationery",
      label: "Stationery",
      icon: "fas fa-scroll me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Spare Parts",
      label: "Spare Parts",
      icon: "fas fa-wrench me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Electrical",
      label: "Electrical",
      icon: "fas fa-bolt me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Needle",
      label: "Needle",
      icon: "fas fa-syringe me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Medical",
      label: "Medical",
      icon: "fas fa-capsules me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Fire",
      label: "Fire",
      icon: "fas fa-fire me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compressor & boiler",
      label: "Compressor & boiler",
      icon: "fas fa-stopwatch me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Chemical",
      label: "Chemical",
      icon: "fas fa-flask me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Printing",
      label: "Printing",
      icon: "fas fa-print me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/It",
      label: "It",
      icon: "fas fa-server me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/WTP",
      label: "WTP",
      icon: "fas fa-water me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compliance",
      label: "Compliance",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Vehicle",
      label: "Vehicle",
      icon: "fas fa-car me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Mechanical",
      label: "Mechanical",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/requisitions",
      label: "Requisitions",
      icon: "fas fa-border-all me-1",
    },
    {
      path: "/requisitions-pending",
      label: "Pending Purchase",
      icon: "fas fa-info me-1 ml-25 no_circle",
    },

    {
      path: "/employees",
      label: "Employees",
      icon: "fas fa-store me-1",
    },
    {
      path: "/teams",
      label: "Teams",
      icon: "fas fa-store me-1",
    },
    {
      path: "/buyers",
      label: "Buyers",
      icon: "fas fa-store me-1",
    },
    {
      path: "/suppliers",
      label: "Suppliers",
      icon: "fas fa-store me-1",
    },
  ],

  "Factory Incharge": [
    {
      path: "/sub-stores",
      label: "Sub-Store",
      icon: "fas fa-store me-1",
    },
    //SUBSTORE SUBMENU

    {
      path: "/sub-stores/Stationery",
      label: "Stationery",
      icon: "fas fa-scroll me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Spare Parts",
      label: "Spare Parts",
      icon: "fas fa-wrench me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Electrical",
      label: "Electrical",
      icon: "fas fa-bolt me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Needle",
      label: "Needle",
      icon: "fas fa-syringe me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Medical",
      label: "Medical",
      icon: "fas fa-capsules me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Fire",
      label: "Fire",
      icon: "fas fa-fire me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compressor & boiler",
      label: "Compressor & boiler",
      icon: "fas fa-stopwatch me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Chemical",
      label: "Chemical",
      icon: "fas fa-flask me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Printing",
      label: "Printing",
      icon: "fas fa-print me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/It",
      label: "It",
      icon: "fas fa-server me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/WTP",
      label: "WTP",
      icon: "fas fa-water me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compliance",
      label: "Compliance",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Vehicle",
      label: "Vehicle",
      icon: "fas fa-car me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Mechanical",
      label: "Mechanical",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/requisitions",
      label: "Requisitions",
      icon: "fas fa-border-all me-1",
    },
    {
      path: "/requisitions-pending",
      label: "Pending Purchase",
      icon: "fas fa-info me-1 ml-25 no_circle",
    },
  ],
  Manager: [
    {
      path: "/sub-stores",
      label: "Sub-Store",
      icon: "fas fa-store me-1",
    },
     //SUBSTORE SUBMENU

     {
      path: "/sub-stores/Stationery",
      label: "Stationery",
      icon: "fas fa-scroll me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Spare Parts",
      label: "Spare Parts",
      icon: "fas fa-wrench me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Electrical",
      label: "Electrical",
      icon: "fas fa-bolt me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Needle",
      label: "Needle",
      icon: "fas fa-syringe me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Medical",
      label: "Medical",
      icon: "fas fa-capsules me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Fire",
      label: "Fire",
      icon: "fas fa-fire me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compressor & boiler",
      label: "Compressor & boiler",
      icon: "fas fa-stopwatch me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Chemical",
      label: "Chemical",
      icon: "fas fa-flask me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Printing",
      label: "Printing",
      icon: "fas fa-print me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/It",
      label: "It",
      icon: "fas fa-server me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/WTP",
      label: "WTP",
      icon: "fas fa-water me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compliance",
      label: "Compliance",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Vehicle",
      label: "Vehicle",
      icon: "fas fa-car me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Mechanical",
      label: "Mechanical",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/requisitions",
      label: "Requisitions",
      icon: "fas fa-border-all me-1",
    },
    {
      path: "/requisitions-pending",
      label: "Pending Purchase",
      icon: "fas fa-info me-1 ml-25 no_circle",
    },
  ],
  "Assistant Manager": [
    {
      path: "/sub-stores",
      label: "Sub-Store",
      icon: "fas fa-store me-1",
    },
     //SUBSTORE SUBMENU

     {
      path: "/sub-stores/Stationery",
      label: "Stationery",
      icon: "fas fa-scroll me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Spare Parts",
      label: "Spare Parts",
      icon: "fas fa-wrench me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Electrical",
      label: "Electrical",
      icon: "fas fa-bolt me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Needle",
      label: "Needle",
      icon: "fas fa-syringe me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Medical",
      label: "Medical",
      icon: "fas fa-capsules me-1 ml-25 no_circle",
    },

    {
      path: "/sub-stores/Fire",
      label: "Fire",
      icon: "fas fa-fire me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compressor & boiler",
      label: "Compressor & boiler",
      icon: "fas fa-stopwatch me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Chemical",
      label: "Chemical",
      icon: "fas fa-flask me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Printing",
      label: "Printing",
      icon: "fas fa-print me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/It",
      label: "It",
      icon: "fas fa-server me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/WTP",
      label: "WTP",
      icon: "fas fa-water me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Compliance",
      label: "Compliance",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Vehicle",
      label: "Vehicle",
      icon: "fas fa-car me-1 ml-25 no_circle",
    },
    {
      path: "/sub-stores/Mechanical",
      label: "Mechanical",
      icon: "fas fa-lemon me-1 ml-25 no_circle",
    },
    {
      path: "/requisitions",
      label: "Requisitions",
      icon: "fas fa-border-all me-1",
    },
    {
      path: "/requisitions-pending",
      label: "Pending Purchase",
      icon: "fas fa-info me-1 ml-25 no_circle",
    },
  ],
};
